var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-part",style:(_vm.extraItem.extras('activityTheme.display') == 1 ||
    _vm.extraItem.extras('activityTime.display') == 1 ||
    _vm.extraItem.extras('activityPlace.display') == 1 ||
    _vm.extraItem.extras('activitySchedule.display') == 1 ||
    _vm.platform == 'wap'
      ? ''
      : 'width:80%')},[_c('div',{staticClass:"u-success",style:({
      display:
        _vm.extraItem.extras('signSuccessTitle.display') == 0 ? 'none' : 'block',
      color: _vm.extraItem.extras('signSuccessTitle.color'),
      fontSize: _vm.pxOrVw(_vm.extraItem.extras('signSuccessTitle.size')),
      fontWeight:
        _vm.extraItem.extras('signSuccessTitle.weight') == 'default'
          ? '500'
          : _vm.extraItem.extras('signSuccessTitle.weight'),
    })},[_vm._v(" "+_vm._s(_vm._f("extra")(_vm.extras,"signSuccessTitle.model"))+" ")]),_c('div',{staticClass:"t-success",style:({
      display:
        _vm.extraItem.extras('signDisplayImg.display', 0) == 0 ? 'block' : 'none',
      border:
        _vm.extraItem.extras('qrcodeborderdisplay.display', 1) == 1
          ? '1px solid #e9e9e9'
          : '0px',
    })},[(_vm.extraItem.extras('qrcodedisplay.display', 1) == 1)?_c('div',{staticClass:"code-tip"},[_vm._v(" 参会凭证 ")]):_vm._e(),_c('div',{staticClass:"code-qrcode",attrs:{"id":"signUpQrCode"}}),_c('div',{staticClass:"code-person"},[_vm._v("参会人ID："+_vm._s(_vm.contactId))])]),_c('div',{staticClass:"t-success",style:({
      display:
        _vm.extraItem.extras('signDisplayImg.display', 0) != 0 ? 'block' : 'none',
      border:
        _vm.extraItem.extras('qrcodeborderdisplay.display', 1) == 1
          ? '1px solid #e9e9e9'
          : '0px',
    })},[_c('div',{staticClass:"code-qrcode",attrs:{"id":"signUpQrCode"}},[_c('img',{staticStyle:{"display":"block"},attrs:{"src":_vm.extraItem.extras('signDisplayImg.src')}})])]),_c('div',{staticClass:"t-success-desc",style:({
      display:
        _vm.extraItem.extras('signSuccessText.display') == 0 ? 'none' : 'block',
      color: _vm.extraItem.extras('signSuccessText.color'),
      fontSize: _vm.pxOrVw(_vm.extraItem.extras('signSuccessText.size')),
      fontWeight:
        _vm.extraItem.extras('signSuccessText.weight') == 'default'
          ? '500'
          : _vm.extraItem.extras('signSuccessText.weight'),
    })},[_vm._v(" "+_vm._s(_vm._f("extra")(_vm.extras,"signSuccessText.model"))+" ")]),(_vm.platform == 'pc' && _vm.extraItem.extras('successButton.display') == 1)?_c('div',{staticClass:"u-post"},[_c('a-button',{staticClass:"submit",attrs:{"type":"primary"},on:{"click":function($event){_vm.gotoUrl(_vm.extraItem.extras('successButton.link_link'))}}},[_vm._v(" "+_vm._s(_vm._f("extra")(_vm.extras,"successButton.link_text"))+" ")])],1):_vm._e(),(
      _vm.platform == 'wap' && _vm.extraItem.extras('signSuccessPost.display') == 1
    )?_c('div',{staticClass:"u-post"},[_c('a-button',{staticClass:"submit",style:({
        display:
          _vm.extraItem.extras('signSuccessPost.display') == 1 ? 'block' : 'none',
      }),attrs:{"type":"primary","disabled":_vm.posterInfo.poster && _vm.posterInfo.poster.status != undefined},on:{"click":function($event){return _vm.goInvite()}}},[_vm._v(" "+_vm._s(_vm._f("extra")(_vm.extras,"signSuccessPost.model"))+" ")])],1):_vm._e(),(_vm.platform == 'wap' && _vm.extraItem.extras('successButton.display') == 1)?_c('div',{staticClass:"u-post"},[_c('a-button',{staticClass:"submit",attrs:{"type":"primary"},on:{"click":function($event){_vm.gotoUrl(_vm.extraItem.extras('successButton.link_link'))}}},[_vm._v(" "+_vm._s(_vm._f("extra")(_vm.extras,"successButton.link_text"))+" ")])],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }